import React from 'react';
import ReactDOM from 'react-dom/client';
import './Styles/index.css';
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import theme from './Theme';
import { Analytics } from '@vercel/analytics/react';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
        <App />
        <Analytics />
    </ThemeProvider>
  </React.StrictMode>
);
